module.exports = __webpack_public_path__ + "img/contact8.4df235b3.png";